<template>
    <LayoutSub :parent="this.$route.path?.split('/')[2]" className="pb-0 hotplace">
        <section class="title_section">
            <div class="hash_box">
                <span class="hash_item">#실방문 횟수 기반의 매장 순위</span>
                <span class="hash_item">#꼼꼼하고 진솔한 리뷰</span>
                <span class="hash_item">#외출에 꼭 필요한 어플리케이션</span>
            </div>
            <h2><span class="c-orange">리얼 데이터</span>로 전국 곳곳의 <br />맛집을 안내해주는 <span class="c-red">핫플레이스</span></h2>
            <div class="app_download_wrap">
                <button>
                    <a href="https://play.google.com/store/apps/details?id=kr.kicc.hotplace&hl=ko" target="_blank">
                        <img src="@/assets/google_play_logo.png" alt="" />
                    </a>
                </button>
                <button>
                    <a href="https://apps.apple.com/kr/app/%ED%95%AB%ED%94%8C%EB%A0%88%EC%9D%B4%EC%8A%A4-%EB%82%B4-%EC%86%90%EC%95%88%EC%9D%98-%EC%A7%80%EC%97%AD%EC%A0%95%EB%B3%B4%EC%95%B1/id904529453"
                        target="_blank">
                        <img src="@/assets/app_store_logo.png" alt="" />
                    </a>
                </button>
            </div>
            <div class="video_area">
                <iframe :src="`https://www.youtube.com/embed/cPyZry-cuUs`" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </section>
        <section class="hot_place_section2">
            <div class="inner">
                <div class="left_area">
                    <i class="ic_hp_top_icon">
                        <img src="@/assets/ic_footprint.png" alt="" />
                    </i>
                    <h3 class="area_title"><span class="c-red">실제 고객 방문 횟수 기반</span>의 <br />정직한 매장 순위</h3>
                    <p class="area_desc">
                        다양한 업종의 40만개의 가게에 설치된 POS 시스템을 근거로 한 실제 정보<br />쉽고 간편하게 보는 내 주변 핫플레이스
                    </p>
                </div>
                <div class="right_area">
                    <img src="@/assets/hp_image1.png" alt="" />
                </div>
            </div>
        </section>
        <section class="hot_place_section3">
            <div class="inner top_inner">
                <div class="left_area">
                    <img src="@/assets/hp_image2.png" alt="" />
                </div>
                <div class="right_area">
                    <div class="area_inner">
                        <i class="ic_hp_top_icon">
                            <img src="@/assets/ic_pencil.png" alt="" />
                        </i>
                        <h3 class="area_title">광고없이 꼼꼼하고 <br /><span class="c-red">솔직한 리뷰</span></h3>
                        <p class="area_desc">
                            직접 다녀오고 체험한 맛집, 멋집만 상세하게 리뷰하는 에디터 추천<br />
                            매달 새로운 테마, 그리고 새로운 매장 TOP10을 직접 다녀 온 후 <br />
                            추천하는 이 달의 핫플레이스
                        </p>
                    </div>
                </div>
            </div>
            <div class="inner bottom_inner">
                <div class="left_area">
                    <i class="ic_hp_top_icon">
                        <img src="@/assets/ic_monit.png" alt="" />
                    </i>
                    <h3 class="area_title">눈길을 사로잡는 <span class="c-red">영상들</span></h3>
                    <p class="area_desc">
                        눈이 즐거운 핫플레이스 영상들을 직접 담아 소개해드립니다.<br />
                        볼거리 풍성한 핫플레이스 유튜브에도 놀러오세요!
                    </p>
                    <a class="youtube_button"
                        href="https://www.youtube.com/@%ED%95%AB%ED%94%8C%EB%A0%88%EC%9D%B4%EC%8A%A4" target="_blank">
                        <i class="ic_youtube">
                            <img src="@/assets/ic_youtube_w.png" alt="" />
                        </i>
                        <span>핫플레이스 채널 바로가기</span>
                    </a>
                </div>
                <div class="right_area">
                    <img src="@/assets/hp_image3.png" alt="" class="over_image" />
                </div>
            </div>
        </section>
        <section class="hot_place_qna_section">
            <div class="inner">
                <h3>자주 묻는 질문</h3>
                <ul>
                    <HotPlaceQnA q_content="핫플레이스 가게 리스트는 어떤 기준으로랭크되는 건가요?"
                        a_content="KICC에서 독점으로 소유하고 있는 가게 카드거래 & 현금영수증 건수 기반으로 통계된 정보로 순위가나열됩니다. 순위는 매주 업데이트되어 유저들에게 신선하고 투명한 정보를 제공하려 노력하고 있습니다." />
                    <HotPlaceQnA q_content="핫플레이스는 맛집 어플리케이션인가요?"
                        a_content="핫플레이스에는 맛집 뿐 아닌, 오락시설, 의료시설, 학원, 숙박시설, 제품판매업종 등 20여개 이상의다양한 업종을 소개하는 지역정보 어플리케이션입니다." />

                    <HotPlaceQnA q_content="핫플레이스에선 광고비를 받고 가게를 소개해주는 건가요?"
                        a_content="핫플레이스는 광고비를 받지 않습니다. 전문 에디터들이 수시간 조사하고 논의하여 선정한 핫플레이스만 직접 다녀온 후, PLAY 핫플, 에디터 추천, 이달의 핫플레이스에 소개하고 있습니다." />

                    <HotPlaceQnA q_content="핫메뉴, 다른 테이블 뭐먹지?는 어떻게 보여지는 건가요?"
                        a_content="핫메뉴 서비스는 EasyPOS 시스템에 입력된 주문 정보를 지난 7일 단위로 통계하여 인기 메뉴 순위를 보여주며, 다른 테이블 뭐 먹지?는 실시간 주문 내역을 토대로 바로 바로 옆 테이블이 주문한 메뉴를 알려주는 신개념서비스 입니다." />

                    <HotPlaceQnA q_content="이벤트는 뭔가요?"
                        a_content="핫플레이스에서는 매일 참여할 수 있는 출석체크 이벤트, 그 외 SNS 및 유튜브 이벤트를 수시로 진행하고 있습니다. 상시 확인하셔서 푸짐한 경품을 받아보세요." />
                </ul>
            </div>
        </section>
    </LayoutSub>
</template>
<script>
import HotPlaceQnA from '@/components/HotPlaceQnA.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        HotPlaceQnA,
    },
};
</script>
<style lang="scss" scoped></style>
